export const getChannelsPermissionsStatus = (userPermissionsMethods, plataformModulesMethod) => {
  const channelsPermission = {
    sms: userPermissionsMethods.havePagePermission('campanhas/sms'),
    whatsapp: userPermissionsMethods.havePagePermission('campanhas/whatsapp') && plataformModulesMethod()['whatsapp'],
    push: userPermissionsMethods.havePagePermission('campanhas/aplicativo') && plataformModulesMethod()['push'],
    email: userPermissionsMethods.havePagePermission('campanhas/email-v2') && plataformModulesMethod()['email_v2'],
    maria_campaign: userPermissionsMethods.havePagePermission('maria/campanha-da-maria'),
    highlight: userPermissionsMethods.havePagePermission('mobile/destaques'),
    banner: userPermissionsMethods.havePagePermission('mobile/banners') && plataformModulesMethod()['mobile'],
  }

  return channelsPermission
}

export const checkIfSomeChannelIsAllowed = (channelsPermissionsStatus) => {
  return Object.entries(channelsPermissionsStatus).some(([key, hasChannelPermission]) => hasChannelPermission)
}
